import {ILauncherDrawerService} from './launcher-drawer.service.interface';
import {action, observable} from 'mobx';
import {LauncherServiceBase} from '../launcher-service-base';
import {ILauncherServiceFactory} from '../launcher-service-factory.interface';

export class LauncherDrawerService extends LauncherServiceBase implements ILauncherDrawerService {

    constructor(services: ILauncherServiceFactory) {
        super(services);
        this.reaction(() => this.services.deviceTypeDetection.isMobile,
            (isMobile) => {
                this.isDrawerOpen = !isMobile;
            });
        this._setIsDrawerOpen(!this.services.deviceTypeDetection.isMobile);
    }

    @observable.ref
    isDrawerOpen: boolean = true;

    @action.bound
    private _setIsDrawerOpen(value: boolean): void {
        this.isDrawerOpen = value;
    }

    toggleDrawer(): void {
        if(this.services.deviceTypeDetection.isMobile) {
            this._setIsDrawerOpen(!this.isDrawerOpen);
        }

    }

}